export default __webpack_public_path__ + "static/media/image3.89f40431.png";